<template>
  <a-modal
    v-bind="$attrs"
    v-on="$listeners"
    :visible="visible"
    @cancel="handleCancel"
  >
    <template slot="footer">
      <a-button key="cancel" :loading="loading" @click="handleCancel">
        取消
      </a-button>
      <a-button key="submit" type="primary" :loading="loading" @click="handleOk">
        确定
      </a-button>
    </template>
    <a-form v-bind="formItemLayout" :form="modifyForm" @submit="handleOk">
      <a-form-item label="渠道">
        <a-select
          class="modal-form"
          placeholder="请选择渠道"
          disabled
          showSearch
          optionFilterProp="label"
          v-decorator="
           ['channelNo', { initialValue: item.channelNo, rules: [{ required: true, validateTrigger: 'change', type: 'string', message: '渠道不能为空' }] }]"
        >
          <a-select-option v-for="(it, id) in channelList" :key="id" :value="it.channelNo" :label="it.channelName">
            {{it.channelName}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="渠道账号">
        <a-input
          placeholder="请输入渠道账号"
          disabled
          class="modal-form"
          v-decorator="
           ['channelAcctNo', { initialValue: item.channelAcctNo, rules: [{ required: true, type: 'string', message: '渠道账号不能为空' }] }]"
        ></a-input>
      </a-form-item>
      <a-form-item label="渠道账号科目编号">
        <a-input
          placeholder="请输入渠道账号科目编号"
          class="modal-form"
          disabled
          v-decorator="
           ['channelAcctSubjectNo', { initialValue: item.channelAcctSubjectNo, rules: [{ required: true, type: 'string', message: '渠道账号科目编号不能为空' }] }]"
        ></a-input>
      </a-form-item>
      <a-form-item label="渠道账户名称">
        <a-input
          placeholder="请输入渠道账户名称"
          class="modal-form"
          v-decorator="
           ['channelAcctName', { initialValue: item.channelAcctName, rules: [{ required: false, type: 'string', message: '渠道账户名称不能为空' }] }]"
        ></a-input>
      </a-form-item>
      <a-form-item label="渠道账户币种类型">
        <a-select
          class="modal-form"
          placeholder="请选择渠道账户币种类型"
          disabled
          showSearch
          optionFilterProp="label"
          v-decorator="
           ['channelAcctCurType', { initialValue: item.channelAcctCurType, rules: [{ required: true, validateTrigger: 'change', type: 'string', message: '渠道账户币种类型不能为空' }] }]"
        >
          <a-select-option v-for="(it, id) in channelAcctCurTypeList" :key="id" :value="it.code" :label="it.name">
            {{it.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="币种" v-if="this.modifyForm.getFieldValue('channelAcctCurType') === '01'">
        <a-select
          class="modal-form"
          placeholder="请选币种"
          disabled
          showSearch
          optionFilterProp="label"
          v-decorator="
           ['singleCur', { initialValue: Object.keys(item.channelAcctCurAmtMap)[0], rules: [{ required: true, validateTrigger: 'change', type: 'string', message: '币种不能为空' }] }]"
        >
          <a-select-option
            v-for="(it, id) in currencyList"
            :key="id"
            :value="it.currencyCode"
            :label="`${it.currencyCode} - ${it.currencyName}`"
          >
            {{it.currencyCode}} - {{it.currencyName}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="币种" v-if="this.modifyForm.getFieldValue('channelAcctCurType') === '02'">
        <a-checkbox-group
          v-decorator="
           ['multiCur', { initialValue: Object.keys(item.channelAcctCurAmtMap), rules: [{ required: true, validateTrigger: 'change', type: 'array', message: '币种不能为空' }] }]"
        >
          <a-row>
            <a-col
              v-for="(ite, index) in currencyList"
              :key="index"
              :span="4"
            >
              <a-checkbox
                :disabled="ite.disabled"
                :value="ite.currencyCode"
              >
                {{ite.currencyCode}}
              </a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  name: 'UpdateAccount',
  props: {
    channelList: {
      type: Array
    },
    item: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    visible: false,
    loading: false,
    modifyForm: null,
    formItemLayout: Object.freeze({
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 19
      }
    }),
    currencyList: [],
    channelAcctCurTypeList: Object.freeze([
      {
        code: '01',
        name: '单币种'
      },
      {
        code: '02',
        name: '多币种'
      }
    ])
  }),
  created () {
    this.modifyForm = this.$form.createForm(this, {
      name: 'modifyForm'
    })
  },
  watch: {
    item: {
      handler (c) {
        this.initForm()
      },
      deep: true
    }
  },
  methods: {
    initForm () {
      if (this.item) {
        const { channelAcctCurType } = this.item
        this.modifyForm.setFieldsValue({
          channelAcctCurType
        })
        // 多币种置灰
        const { channelAcctCurAmtMap } = this.item
        const keys = Object.keys(channelAcctCurAmtMap)
        this.currencyList.forEach(it => {
          it.disabled = keys.includes(it.currencyCode)
        })
      }
    },
    async getCurrency () {
      const response = await this.$http.swap.queryAllCurrencyConf({})
      const { succ, data, msg } = response
      if (!succ) {
        this.$message.error(msg)
        return false
      } else {
        this.currencyList = data
      }
    },
    handleCancel () {
      this.visible = false
      this.modifyForm.resetFields()
    },
    handleOk () {
      this.modifyForm.validateFields(async (err, values) => {
        if (!err) {
          const { channelAcctCurType, singleCur, multiCur } = values
          const params = {
            ...values,
            curTypes: channelAcctCurType === '01' ? [singleCur] : multiCur,
            id: this.item.id
          }
          this.loading = true
          const { succ } = await this.$http.channel.channelAcctUpdate(params)
          this.loading = false
          if (succ) {
            this.$message.success('修改成功！')
            this.handleCancel()
            this.$emit('success')
          }
        }
      })
    },
    handleClose () {
      this.startOpen = false
      this.endOpen = false
    }
  }
}
</script>

<style scoped lang="less">
@import "~@/components/modal-form.less";
</style>
